// src/components/store/sections/blog-posts/BlogV65CyberfeedEmeraldMint.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV65CyberfeedEmeraldMint(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={65}
      archKey="cyber_feed"
      archLabel="Cyberpunk News Matrix"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
